import { useState } from "react";
import { useUserStore } from "../../../store";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebaseConfig";

const useMyTransfers = ({ ticker }: { ticker?: string }) => {
  const ordAddress = useUserStore((state) => state.ordAddress);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [myTransfers , setMyTransfers] = useState<any[]>([]);
  const [myAvailableBalance , setMyAvailableBalance] = useState(0);

  if (!ticker) {
    return {
      isLoading,
      error,
      myTransfers,
      fetchMyTransfers: () => {},
    };
  }
  const fetchMyTransfers = async () => {
    setIsLoading(true);
    try {
      const getValidTransfers = httpsCallable(functions, "getValidTransfers");
      const response: any = await getValidTransfers({ ticker, address: ordAddress });
      setMyTransfers(response.data.transfers);
      setMyAvailableBalance(response.data.availableBalance);
      setError(null);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unexpected error occurred.");
      }
      setMyTransfers([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    myTransfers,
    myAvailableBalance,
    fetchMyTransfers,
  };
};

export default useMyTransfers;
